var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import { notification } from 'antd';
import { useTranslation } from 'react-i18next';
import MainHeading from '../MainHeading';
import PutAwayCandidateList from './PutAwayCandidateList';
import PutAwayDetail from './PutAwayDetail';
import usePutAwayQueue from './usePutAwayQueue';
var PutAwayV2 = function (_a) {
    var setIsLoading = _a.setIsLoading;
    var t = useTranslation().t;
    var _b = usePutAwayQueue(), isLoading = _b.isLoading, fetchCandidates = _b.fetchCandidates, resolveTarget = _b.resolveTarget, searchLocations = _b.searchLocations, validateLocation = _b.validateLocation, move = _b.move;
    var _c = useState('list'), subscreen = _c[0], setSubscreen = _c[1];
    var _d = useState([]), candidates = _d[0], setCandidates = _d[1];
    var _e = useState(null), target = _e[0], setTarget = _e[1];
    var _f = useState(''), scanError = _f[0], setScanError = _f[1];
    var _g = useState(0), focusSignal = _g[0], setFocusSignal = _g[1];
    var _h = useState(false), moving = _h[0], setMoving = _h[1];
    var loadCandidates = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setIsLoading(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    _a = setCandidates;
                    return [4 /*yield*/, fetchCandidates()];
                case 2:
                    _a.apply(void 0, [_c.sent()]);
                    return [3 /*break*/, 5];
                case 3:
                    _b = _c.sent();
                    notification.error({ message: t('Error'), description: t('Could not load put-away list.') });
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [fetchCandidates, setIsLoading, t]);
    useEffect(function () {
        void loadCandidates();
    }, [loadCandidates]);
    var openTarget = useCallback(function (scanId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, resolved, error;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setScanError('');
                    setIsLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, resolveTarget(scanId)];
                case 2:
                    _a = _b.sent(), resolved = _a.target, error = _a.error;
                    if (error || !resolved) {
                        setScanError(error || t('Nothing found for that scan'));
                        setFocusSignal(function (n) { return n + 1; });
                        return [2 /*return*/];
                    }
                    setTarget(resolved);
                    setSubscreen('detail');
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [resolveTarget, setIsLoading, t]);
    var handleConfirm = useCallback(function (toLocationSeqId) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!target)
                        return [2 /*return*/];
                    setMoving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 6, 7]);
                    return [4 /*yield*/, move({
                            containerId: target.moveType === 'container' ? target.containerId : null,
                            assetId: target.moveType === 'asset' ? target.assetId : null,
                            toLocationSeqId: toLocationSeqId
                        })];
                case 2:
                    res = _a.sent();
                    if (!res.ok) return [3 /*break*/, 4];
                    notification.success({
                        message: t('Moved'),
                        description: res.message || t('Put away complete.')
                    });
                    setTarget(null);
                    setSubscreen('list');
                    setFocusSignal(function (n) { return n + 1; });
                    return [4 /*yield*/, loadCandidates()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    notification.error({
                        message: t('Error'),
                        description: res.error || t('Move failed')
                    });
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    setMoving(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); }, [target, move, loadCandidates, t]);
    return (_jsxs("div", __assign({ className: 'px-4 sm:px-8 lg:px-16 pt-1 lg:pt-3 pb-16 h-screen w-full sm:w-4/5 md:w-3/5 lg:w-2/5 mx-auto' }, { children: [_jsx(MainHeading, { heading: t('Put Away') }, void 0), _jsx("div", __assign({ className: 'bg-white p-5 rounded-lg shadow-sm' }, { children: subscreen === 'list' ? (_jsx(PutAwayCandidateList, { candidates: candidates, loading: isLoading, scanError: scanError, focusSignal: focusSignal, onScan: openTarget, onPick: function (c) { return openTarget(c.scanId); }, onRefresh: function () { return void loadCandidates(); } }, void 0)) : target ? (_jsx(PutAwayDetail, { target: target, moving: moving, onSearchLocations: searchLocations, onValidateLocation: validateLocation, onConfirm: handleConfirm, onBack: function () {
                        setTarget(null);
                        setSubscreen('list');
                        setFocusSignal(function (n) { return n + 1; });
                    } }, void 0)) : null }), void 0)] }), void 0));
};
export default PutAwayV2;
